/**
 * Contrato del ranking de profesionales (`/professionals` desktop + cards #40).
 * Ver docs/PROFESSIONALS_RANKING_CONTRACT.md
 */

import type { RetentionStatus } from './ownerPvpRetentionTypes';

export type ProfesionalProductionTrend = 'up' | 'down' | 'flat' | 'new';

export interface OwnerProfessionalRankingRow {
  tenantId: string;
  profesionalId: number;
  nombre: string;
  turnosAtendidos: number;
  ingresos: number;
  deltaIngresosPct: number | null;
  deltaTurnosPct: number | null;
  trend: ProfesionalProductionTrend;
  pvp: number | null;
  pvpVariacionPct: number | null;
  pvpPromedioHistorico: number | null;
  status: RetentionStatus;
}

export interface OwnerProfessionalsRanking {
  scope: 'owner-professionals';
  period: string;
  rows: OwnerProfessionalRankingRow[];
  totals: {
    profesionales: number;
    enAtencion: number;
    enCaida: number;
  };
}

/** Búsqueda desktop (y cards #40): nombre o #id. */
export function matchesProfessionalNameSearch(
  row: Pick<OwnerProfessionalRankingRow, 'nombre' | 'profesionalId'>,
  query: string
): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  const name = (row.nombre || '').toLowerCase();
  const id = String(row.profesionalId);
  return name.includes(needle) || id.includes(needle);
}
